import React from 'react';
import { ReactComponent as Date } from '../../assets/icons/fecha.svg';
import { ReactComponent as Duration } from '../../assets/icons/duracion.svg';
import { ReactComponent as Price } from '../../assets/icons/precio.svg';
import { Trip } from '../../types/trip';

interface DataTravelProps {
    data: Trip;
    loading: boolean;
    error: any;
    isExperience?: boolean;
}

const getTimeRange = (times: string[]) => {
    const sortedTimes = [...times].sort();
    return {
        earliest: sortedTimes[0],
        latest: sortedTimes[sortedTimes.length - 1],
    };
}

const DataTravelComponent: React.FC<DataTravelProps> = ({ data, loading, error, isExperience }) => {
    if (loading) return <p></p>;
    if (error) return <p></p>;

    const { date1, date2, days, price, available_time_spots } = data;
    const { earliest, latest } = available_time_spots ? getTimeRange(available_time_spots) : {
        earliest: '',
        latest: '',
    };

    return (
        <div className="data-component">
            {(date1 && date2) && (
                <div className="data one">
                    <div className="icon">
                        <Date />
                    </div>
                    <div className="more-info">
                        <h3>{isExperience ? 'Fechas disponibles' : 'Fechas'}</h3>
                        <div className="fechas">
                            <p>{date1} a {date2}</p>
                        </div>
                    </div>
                </div>
            )}

            {days && (
                <div className="data two">
                    <div className="icon">
                        <Duration />
                    </div>
                    <div className="more-info">
                        <h3>Duración</h3>
                        <p>{days + 1} días</p>
                    </div>
                </div>
            )}

            {available_time_spots && available_time_spots?.length > 0 && (
                <div className="data two">
                    <div className="icon">
                        <Duration />
                    </div>
                    <div className="more-info">
                        <h3>Salidas</h3>
                        <p>de {earliest} a {latest}</p>
                    </div>
                </div>
            )}

            {price.value && (
                <div className="data three">
                    <div className="icon">
                        <Price />
                    </div>
                    <div className="more-info">
                        <h3>Precio</h3>
                        <p>{price.prefix} {price.currency} {price.value}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default DataTravelComponent;
